
import React from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Provider } from "@supabase/supabase-js";
import SocialLogin from "./SocialLogin";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";
import { useNavigate } from "react-router-dom";

interface AuthCardProps {
  handleLoginSubmit: (email: string, password: string) => Promise<void>;
  handleSignupSubmit: (email: string, password: string, username: string) => Promise<void>;
  handleSocialLogin: (provider: Provider) => Promise<void>;
  isLoading: boolean;
  socialLoading: Provider | null;
}

const AuthCard = ({ 
  handleLoginSubmit, 
  handleSignupSubmit, 
  handleSocialLogin, 
  isLoading, 
  socialLoading 
}: AuthCardProps) => {
  const navigate = useNavigate();

  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle className="text-center text-2xl">3DP Hub</CardTitle>
        <CardDescription className="text-center">
          Sign in to your account or create a new one
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <SocialLogin 
            onSocialLogin={handleSocialLogin} 
            socialLoading={socialLoading} 
          />
          
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <span className="w-full border-t" />
            </div>
            <div className="relative flex justify-center text-xs uppercase">
              <span className="bg-background px-2 text-muted-foreground">
                Or continue with
              </span>
            </div>
          </div>
          
          <Tabs defaultValue="login">
            <TabsList className="grid w-full grid-cols-2">
              <TabsTrigger value="login">Login</TabsTrigger>
              <TabsTrigger value="signup">Sign Up</TabsTrigger>
            </TabsList>
            
            <TabsContent value="login">
              <LoginForm 
                onSubmit={handleLoginSubmit} 
                isLoading={isLoading} 
              />
            </TabsContent>
            
            <TabsContent value="signup">
              <SignupForm 
                onSubmit={handleSignupSubmit} 
                isLoading={isLoading} 
              />
            </TabsContent>
          </Tabs>
        </div>
      </CardContent>
      <CardFooter>
        <Button 
          variant="outline" 
          className="w-full" 
          onClick={() => navigate("/")}
        >
          Back to Home
        </Button>
      </CardFooter>
    </Card>
  );
};

export default AuthCard;
